import { LongArrow } from '@/components/brand/long-arrow';
import { useI18nContext } from '@/i18n/i18n-react';
import type { SlideProps } from '@/lib/whats-new/edition-types';
import { useEstreiaFacts } from '@/components/whats-new/editions/estreia/use-estreia-facts';
import { coverVM } from '@/components/whats-new/editions/estreia/view-models';
import { Eyebrow } from '@/components/whats-new/slides/eyebrow';
import { Rise } from '@/components/whats-new/slides/rise';
import {
  SlideLayout,
  SlideLead,
  SlideTitle,
} from '@/components/whats-new/slides/slide-layout';
import { StoreChip } from '@/components/whats-new/slides/store-chip';
import { WordReveal } from '@/components/whats-new/slides/word-reveal';

/** The white pill of the stage's main action, with the long arrow. */
export const STAGE_PRIMARY_BUTTON =
  'group relative z-[5] inline-flex h-[42px] items-center gap-3 rounded-full bg-white px-[18px] text-sm font-semibold text-[#15191E] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#6FA0FF] max-md:min-h-touch';

/**
 * 1 · Capa (NEWS-28): the store in the title, the edition's promise and
 * "Ver as novidades", which goes to the next slide. The torus sits on the
 * right (≥ 768px) or in the top half (< 768px), drawn by the player.
 */
export function CoverSlide({ next }: SlideProps) {
  const { LL } = useI18nContext();
  const { store } = coverVM(useEstreiaFacts());

  return (
    <SlideLayout
      variant="cover"
      copy={
        <>
          <Rise index={0}>
            <Eyebrow
              lead={LL.whatsNew.editions.estreia.cover.eyebrowLead()}
              trail={LL.whatsNew.editions.estreia.cover.eyebrowTrail()}
            />
          </Rise>
          <SlideTitle size="xl">
            <WordReveal
              text={LL.whatsNew.editions.estreia.cover.title({
                chip: '{chip}',
              })}
              slots={{
                chip: <StoreChip name={store.name} iconUrl={store.iconUrl} />,
              }}
            />
          </SlideTitle>
          <Rise index={2}>
            <SlideLead>{LL.whatsNew.editions.estreia.cover.lead()}</SlideLead>
          </Rise>
          <Rise index={3} className="flex flex-wrap items-center gap-4">
            <button
              type="button"
              onClick={next}
              className={STAGE_PRIMARY_BUTTON}
            >
              {LL.whatsNew.editions.estreia.cover.cta()}
              <LongArrow lineClassName="w-7 group-hover:w-11" />
            </button>
            <span className="text-[12.5px] text-white/[.64]">
              {LL.whatsNew.editions.estreia.cover.hint()}
            </span>
          </Rise>
        </>
      }
    />
  );
}
